module.exports = __webpack_public_path__ + "static/media/hotel.60c9c83a.svg";